<template>
  <div id="ThemesListView" class="view" :style="minHeight">
    <page-intro 
      :sub-title="gpsst.themeIndexSubTitle" 
      :view="'themesList'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-intro>
    <div v-if="themeIndexChapo_g" class="editorial" v-html="themeIndexChapo_g"></div>
    <h4 class="myOrangeTitle" v-html="$t('views.themeListView.titleProposedThemes')"></h4>
    <div 
      v-if="displayRosace" 
      class="themes-container rosace"
      :style="{width: flowerOuterRadius+'px', height: flowerOuterRadius+'px'}"
    >
      <theme-card
        v-for="(theme,index) in proposedThemes"
        :key="theme.ref"
        :theme="theme"
        :index="index"
        :leftPos="themesPositions[index].x"
        :topPos="themesPositions[index].y"
        :displayRosace="displayRosace"
        @click.native="$emit('changeview',{view:'theme', theme:theme})"
      ></theme-card>
    </div>
    <div 
      v-if="!displayRosace" 
      class="themes-container inline"
    >
      <theme-card 
        v-for="(theme,index) in proposedThemes"
        :key="theme.ref"
        :theme="theme"
        :index="index"
        :leftPos="0"
        :topPos="0"
        @click.native="$emit('changeview',{view:'theme', theme:theme})"
      ></theme-card>
    </div>

    <!-- code lié à l'affichage en lignes des thèmes perso -->
    <h4 class="myOrangeTitle" v-html="$t('views.themeListView.titleCustomThemes')"></h4>
    <div class="themes-container inline">
      <theme-card class="custom-theme-card"
        v-for="(theme,index) in customThemes"
        :key="theme.ref"
        :theme="theme"
        :index="index"
        @click.native="$emit('changeview',{view:'theme', theme:theme})"
      ></theme-card>

      <theme-card class="custom-theme-card" :theme="addThemeBtn" @click.native="showAddElementPopin()"></theme-card>
    </div>

    <div class="infoCustomThemes" v-if="customThemes.length>0">
      <info-message :text="$t('views.themeListView.msgThemesPerso')" />
    </div>

    <page-menu
      :view="'themesList'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-menu>

  </div>
</template>


<script>
import PageIntro from "../components/PageIntro";
import PageMenu from "../components/PageMenu";
import ThemeCard from "../components/theme/ThemeCard";
import InfoMessage from "../components/global/InfoMessage";

export default {
  name: "ThemeListView",
  components: {
    PageIntro,
    PageMenu,
    ThemeCard,
    InfoMessage
  },
  props: {
    minHeight: String
  },
  data: function() {
    return {
      displayRosace: false,
      flowerOuterRadius: 0,
      themesPositions: [],
      addThemeBtn: { title: this.$i18n.t('views.themeListView.addThemeBtn'), custom: true, addThemeBtn: true }
    };
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    },
    themeIndexChapo_g: function() {
      return JsonDataModule.getValueWithGlossary(this.gpsst, 'themeIndexChapo'); //eslint-disable-line no-undef
    },    
    customThemes: function() {
      // récupère les thèmes perso
      var themes = this.$store.state.gpsstModule.gpsst.themes;
      var themeList = [];
      for (let i = 0; i < themes.length; i++) {
        if (themes[i].custom) themeList.push(themes[i]);
      }
      themeList.sort(this.randomSort);
      return themeList;
    },
    proposedThemes: function() {
      // récupère les thèmes par défaut
      var themes = this.$store.state.gpsstModule.gpsst.themes;
      var themeList = [];
      if (themes) {
        for (let i = 0; i < themes.length; i++) {
          if (!themes[i].custom) themeList.push(themes[i]);
        }
        themeList.sort(this.randomSort);
      }
      return themeList;
    }
  },
  mounted: function() {
    // calcul des positiosn des petales
    this.themesPositions = this.themesLayout();

    // on teste les variable pour choisir si l'affichage se fera en rosace ou non
    this.displayRosace = this.isRosacePossible();

    // on écoute le changement de taille d'écran afin d'adapter l'affichage rosace en fonction de la place disponible
    window.addEventListener("resize", this.onResize);

    initTooltips("#ThemesListView"); //eslint-disable-line no-undef
  },
  updated: function() {
    initTooltips("#ThemesListView"); //eslint-disable-line no-undef
  },  
  beforeDestroy() {
    // on enlève l'écoute sur l'évènement
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    showAddElementPopin() {
      this.$store.commit("SET_POPIN", {
          type: 'ADD-THEME'
        });
      this.$bvModal.show("addThemeElement");
    },
    /**
     * Indique s'il est possible d'afficher les thèmes standard sous forme de rosace
     * (au moins 3 thèmes + suffisament de largeur disponible)
     */
    isRosacePossible: function() {
      return      this.proposedThemes.length >= 3 
              &&  document.documentElement.clientWidth > (this.flowerOuterRadius + 30);
    },
    // quand la taille d'écran change, on exécute cette fonction et on recalcule les positions de la rosace
    /**
     * Callback appelée lorsque l'affichage change de dimension
     */
    onResize() {
      this.displayRosace = this.isRosacePossible();
      if (this.displayRosace) {
        // On recalcule la position des pétales
        this.themesPositions = this.themesLayout();
      }
    },
    // définition de l'odre aléatoire de l'affichage des thèmes
    randomSort: function(a, b) {
      if (a.randomNumber > b.randomNumber) return -1;
      if (a.randomNumber < b.randomNumber) return 1;
      return 0;
    },
    // génère les positions à appliquer aux ThemeCard pour les afficher sous forme de rosace
    themesLayout: function() {
      // Nb de pétales (>= 3)
      var nbPetals = this.proposedThemes.length;

      // Rayon des pétales
      var petalRadius = 75;

      // Espacement entre les pétales (1/6e de leur rayon - ratio à adapter si besoin)
      var petalSpacing = petalRadius/6;

      // Calcul du rayon de la rosace (= rayon du cercle sur lequel se situe le centre de chaque pétale)
      var flowerRadius = Math.round((petalRadius+petalSpacing)/Math.sin(Math.PI / nbPetals));

      // Calcul des dimensions nécessaires pour l'affichage de la rosace
      // Remarques : 
      // 1) Lors de l'intégration dans l'outil, prévoir de ne pas afficher la rosace (mais les pétales à la queue-leu-leu) si la largeur 
      //    disponible (cf. https://api.jquery.com/width/) est inférieure à la largeur nécessaire calculée ci-dessous OU s'il y a moins de 3 pétales.
      // 2) Si plus de 2 pétales, mettre à jour l'affichage de la liste des thèmes (rosace ou queue-leu-leu) chaque fois que la largeur d'affichage est 
      //    susceptible d'avoir changé (événement correspondant : https://developer.mozilla.org/en-US/docs/Web/API/Window/resize_event)
      var flowerOuterRadius = Math.ceil(2 * (flowerRadius + petalRadius));
      
      // Coordonnées du centre de la rosace (= centre de la zone d'affichage)
      var flowerCenterX = flowerOuterRadius / 2, flowerCenterY = flowerOuterRadius / 2; 

      // Calcul de la position de chaque pétale
      var petals = [];
      var angleStep = -2 * Math.PI / nbPetals;
      
      //var angle = Math.PI * 2 * Math.random(); // variante avec angle de début aléatoire
      var angle = Math.PI / 2; // angle de début fixe (en haut)
      for(var i=0; i<nbPetals; i++) {
          petals.push({
              x : Math.round(Math.cos(angle) * flowerRadius) + flowerCenterX - petalRadius,
              y : -Math.round(Math.sin(angle) * flowerRadius) + flowerCenterY - petalRadius
          });
          angle += angleStep;
      }

      this.flowerOuterRadius = flowerOuterRadius;

      return petals;
    }
  }
};
</script>



<style lang="sass" scoped>
@import '../sass/_variables.sass'

.custom-themes-container
  padding: 0 0 1em 0

.custom-theme-card
  margin-right: 1em
  margin-top: 1em
  position: relative

.themes-container
    position: relative

    &.rosace
      margin: 0 auto

    &.inline
      margin: 0

      .themeCard
        display: inline-block
        vertical-align: top
        margin:0 1em 1em 0

.infoCustomThemes
  margin: 0

</style>

<style lang="sass">
.themes-container
    &.inline
      .themeCard
        margin-top: 0.8em !important
</style>